import service, { HttpResponseSuccess } from '@/services/service';
import { User } from '@/modules/user/userTypes';

const apiClient = service(`${process.env.REACT_BACKEND_HOST}`);

export type PostOnboardingScoringResponse = User;
export type GetOnboardingScoringResponse = {
	scoring: {
		status: 'completed' | 'pending' | 'failed';
		score: number;
		startDate: string;
		endDate: string;
	};
};

export const createOnboardingScore = (): Promise<
	HttpResponseSuccess<PostOnboardingScoringResponse>
> => apiClient.post('/api/user/onboarding/scoring');

export const getOnboardingScore = (): Promise<
	HttpResponseSuccess<GetOnboardingScoringResponse>
> => apiClient.get('/api/user/onboarding/scoring');
